<template>
  <div class="home">
    <!-- プリロード用の画像（非表示） -->
    <div style="display: none;">
      <!-- Icons GIF画像のプリロード -->
      <img :src="exileGifSrc" alt="exile gif preload">
      <img :src="tokeiGifSrc" alt="tokei gif preload">
      <img :src="puzzleGifSrc" alt="puzzle gif preload">
      <img :src="doorGifSrc" alt="door gif preload">
      <!-- OTA画像のプリロード -->
      <img :src="quizImages[0]" alt="otaA preload">
      <img :src="quizImages[1]" alt="otaB preload">
      <img :src="quizImages[2]" alt="otaC preload">
      <img :src="quizImages[3]" alt="otaD preload">
    </div>
    
    <!-- メインキービジュアル -->
    <div class="hero-section">
      <div class="hero-content">
        <img alt="メインタイトル" src="../assets/titleyoko.webp" class="hero-title-desktop animate-in">
        <img alt="メインタイトル" src="../assets/titletate.webp" class="hero-title-mobile animate-in">
      </div>
      <!-- 右上4分の1のクリックエリア -->
      <div class="hero-click-area right" @click="handleHeroClick"></div>
      <!-- 左上4分の1のクリックエリア -->
      <div class="hero-click-area left" @click="handleHeroLeftClick"></div>
    </div>
    <div class="main-content">
      <div class="main-title-container">
        <h2 class="main-title">ナゾラックアウト</h2>
        <a href="" target="_blank" class="main-title-link"><i
            class="fas fa-map-marker-alt"></i>???</a>
      </div>
      <p class="sentence">投げろ、魂の一球。</p>

      <section class="sentence-section">
        <h3 class="sentence-title">ストーリー</h3>
        <p class="sentence-content">
          とある球団でピッチャーをしているあなたたち。ところが最近全員成績不振続きで戦力外通告スレスレの大ピンチ！<br><br>
          ある日謎解きをしながらピッチング能力を上げられる練習法「ナゾラックアウト」を知ったあなたたちは、最後の望みを託すことに。<br><br>
          果たして全てのパネルを打ち抜くことができるのだろうか？
        </p>

        <div class="story-action-section">
          <a href="#" @click.prevent="scrollToQuiz" class="story-quiz-link">
            お試しなぞに挑戦する
          </a>
        </div>
      </section>
      <section class="sentence-section">
        <h3 class="sentence-title">イベント概要</h3>
        <div class="overview-grid">
          <div class="overview-item">
            <div class="overview-label">チーム人数</div>
            <div class="overview-content">
              <!-- 以前のアイコン: <i class="fas fa-users"></i> -->
              <img :src="exileImageSrc" alt="チーム人数" class="overview-icon" @click="playExileAnimation">
              <span>4人まで</span>
            </div>
          </div>

          <div class="overview-item">
            <div class="overview-label">所要時間</div>
            <div class="overview-content">
              <!-- 以前のアイコン: <i class="fas fa-clock"></i> -->
              <img :src="tokeiImageSrc" alt="所要時間" class="overview-icon" @click="playTokeiAnimation">
              <span>60分</span>
            </div>
          </div>

          <div class="overview-item">
            <div class="overview-label">開催場所</div>
            <div class="overview-content">
              <!-- 以前のアイコン: <i class="fas fa-door-open" @click="handleDoorClick"></i> -->
              <img :src="doorImageSrc" alt="開催場所" class="overview-icon" @click="playDoorAnimation">
              <span>屋内</span>
            </div>
          </div>

          <div class="overview-item">
            <div class="overview-label">開催形式</div>
            <div class="overview-content">
              <img :src="puzzleImageSrc" alt="開催形式" class="overview-icon" @click="playPuzzleAnimation">
              <span>ルーム型</span>
            </div>
          </div>
        </div>
        <p class="sentence-content">
          ※スマートフォンを使用します。<br>
          ※野球の知識・技術は必要ありません。
        </p>
      </section>
      <section class="sentence-section">
        <h3 class="sentence-title">開催日程</h3>
        <p class="sentence-content">
          ???
        </p>
        <table class="schedule-table">
          <thead>
            <tr>
              <th>開始時間</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <!-- <td>9:00　10:20　11:40　13:00　<br class="br-sp">14:40　16:00　17:20　18:40　20:00</td> -->
              <td> ??? </td>
            </tr>
          </tbody>
        </table>
        <p class="sentence-content">
          <!-- ※受付開始時間は10分前です。<br></br> -->
          ※謎解き公演という性質上、開始時間に間に合いませんと、チケットをお持ちでも入場できない場合がございます。ご注意ください。
        </p>
      </section>
      <section class="sentence-section">
        <h3 class="sentence-title">チケット価格</h3>
        
        <p class="sentence-content">
          3,000円 / 1人<br>
          当日現金支払い
        </p>
        <!-- 11/1,2の公演は終わりました -->
        <!-- <p class="sentence-content">11月1日(土)・2日(日)の公演は終わりました。</p> -->
      </section>

      <section class="sentence-section access-section">
        <h3 class="sentence-title">アクセス</h3>
        <a href="https://sites.google.com/view/saienfes15/%E3%83%9B%E3%83%BC%E3%83%A0" target="_blank" class="access-link">
          アクセス方法
        </a>
        <div class="access-content">

          <!-- <div class="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d930.3263237400757!2d136.9122060983868!3d35.199802846979374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600371a078900c91%3A0x8c5e0a17405e42ba!2z6KyO6Kej44GN44Kr44OV44Kn77yG44Oc44O844OJ44Ky44O844OgIOOBquOBnuOBreOBkw!5e0!3m2!1sja!2sjp!4v1754806635141!5m2!1sja!2sjp"
              width="400" height="450" style="border:0;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div> -->
          <!-- <div class="address-info">
            <p class="address-text">
              謎解きカフェ＆ボードゲームなぞねこ<br>
              愛知県名古屋市北区黒川本通４丁目４７
            </p>
          </div>
          <div class="access-link">
            <a href="https://nazoneko.jp/" target="_blank">
              <img src="../assets/nazonekos.png" alt="なぞねこ" class="nazonekos-image">
            </a>
          </div> -->
        </div>
      </section>

      <section id="quiz-section" class="sentence-section">
        <h3 class="sentence-title">お試しなぞ</h3>
        <div class="quiz-container">
          <div class="quiz-navigation">

            <!-- 前のなぞのプレビュー（スライドショー風） -->
            <div v-if="currentQuizIndex > 0" class="prev-quiz-preview" @click="previousQuiz">
              <img :src="prevQuizImage" :alt="`前のなぞ ${currentQuizIndex}`" class="preview-image">
            </div>

            <button @click="previousQuiz" :disabled="currentQuizIndex === 0" class="nav-button prev-button"
              :class="{ disabled: currentQuizIndex === 0 }">
              <i class="fas fa-chevron-left"></i>
            </button>

            <div class="quiz-image-container">
              <img :src="currentQuizImage" :alt="`お試しなぞ ${currentQuizIndex + 1}`" class="quiz-image">


            </div>
            <!-- 次のなぞのプレビュー（スライドショー風） -->
            <div v-if="currentQuizIndex < quizImages.length - 1" class="next-quiz-preview" @click="nextQuiz">
              <img :src="nextQuizImage" :alt="`次のなぞ ${currentQuizIndex + 2}`" class="preview-image">
            </div>

            <button @click="nextQuiz" :disabled="currentQuizIndex === quizImages.length - 1"
              class="nav-button next-button" :class="{ disabled: currentQuizIndex === quizImages.length - 1 }">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <div class="quiz-answer-section">
            <div class="answer-input-container">
              <input v-model="userAnswers[currentQuizIndex]" type="text" placeholder="答えを入力してください" class="answer-input"
                @keyup.enter="checkAnswer">
              <button @click="checkAnswer" class="check-button">
                回答
              </button>
            </div>

            <div v-if="showResults[currentQuizIndex]" class="answer-result"
              :class="isCorrects[currentQuizIndex] ? 'correct' : 'incorrect'">
              <i :class="isCorrects[currentQuizIndex] ? 'fas fa-circle-check' : 'fas fa-circle-xmark'"></i>
              <span v-if="isCorrects[currentQuizIndex]">正解！</span>
              <span v-else>不正解</span>
            </div>


          </div>
        </div>
      </section>

      <!-- イベントの感想 -->
      <section id="feedback-section" class="sentence-section feedback-section">
        <h3 class="sentence-title">ナゾラックアウトの感想</h3>
        <div
          ref="feedbackSlider"
          class="feedback-slider"
          :style="feedbackSliderStyle"
          @mouseenter="pauseFeedbackAutoSlide"
          @mouseleave="resumeFeedbackAutoSlide"
          @touchstart="handleFeedbackTouchStart"
          @touchend="handleFeedbackTouchEnd"
        >
          <div
            class="feedback-track"
            ref="feedbackTrack"
          >
            <article
              v-for="(feedback, index) in loopedFeedbacks"
              :key="`feedback-loop-${index}`"
              class="feedback-card"
            >
              <p
                class="feedback-card-body"
                v-html="formatFeedbackBody(feedback.body)"
              ></p>
            </article>
          </div>
        </div>
      </section>
      
      <section class="sentence-section">
        <h3 class="sentence-title">注意事項</h3>
        <p class="sentence-content">
          ※スマートフォンを使用します。<br>
          ※野球の知識・技術は必要ありません。<br>
          ※推奨年齢は13歳以上です。<br>
          ※SNSやブログなどでのネタバレは固くお断りいたします。<br>
          ※その他スタッフの指示には従ってください。<br>
        </p>
      </section>
      <section class="sentence-section hashtag">
        <h4>ハッシュタグ</h4>
        <a
          href="https://x.com/hashtag/%E3%83%8A%E3%82%BE%E3%83%A9%E3%83%83%E3%82%AF%E3%82%A2%E3%82%A6%E3%83%88?f=live">#ナゾラックアウト</a>

      </section>
    </div>


    <!-- フッター -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <a href="https://x.com/evesanta1224" target="_blank" class="creator-link">
            制作者: さんた
          </a>
        </div>
        <router-link to="/admin" class="admin-button"></router-link>
      </div>
    </footer>

    <!-- 管理者ボタン -->

    <!-- シークレットモーダル -->
    <div v-if="secretModal" class="secret-modal-overlay" @click="closeSecretModal">
      <div class="secret-modal" @click.stop>
        <div class="secret-modal-content">
          <h2 class="secret-title">完全試合</h2>
          <p class="secret-message">隠されたもう一つの答えにたどり着いた！</p>
          <div class="secret-share-section">
            <a href="https://twitter.com/intent/tweet?text=%23%E3%83%8A%E3%82%BE%E3%83%A9%E3%83%83%E3%82%AF%E3%82%A2%E3%82%A6%E3%83%88%0A%E3%80%90%E3%81%8A%E8%A9%A6%E3%81%97%E3%81%AA%E3%81%9E%E3%80%91%E5%AE%8C%E5%85%A8%E8%A9%A6%E5%90%88%E9%81%94%E6%88%90%EF%BC%81%0A%0A%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E8%A9%B3%E7%B4%B0%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%0Ahttps%3A%2F%2Fstrucknazo.web.app%0A%40evesanta1224%20%E3%81%8B%E3%82%89"
              target="_blank" class="secret-share-button">
              <i class="fab fa-x-twitter"></i>
              シェアする
            </a>
          </div>

          <button @click="closeSecretModal" class="secret-close-button">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 4問目正解モーダル（1つ目の正解） -->
    <div v-if="quiz4Modal1" class="secret-modal-overlay" @click="closeQuiz4Modal1">
      <div class="secret-modal" @click.stop>
        <div class="secret-modal-content">
          <h2 class="secret-title">完封勝利</h2>
          <p class="secret-message">4枚全部使って正解しました！</p>

          <div class="secret-share-section">
            <a href="https://twitter.com/intent/tweet?text=%23%E3%83%8A%E3%82%BE%E3%83%A9%E3%83%83%E3%82%AF%E3%82%A2%E3%82%A6%E3%83%88%0A%E3%80%90%E3%81%8A%E8%A9%A6%E3%81%97%E3%81%AA%E3%81%9E%E3%80%91%E5%AE%8C%E5%B0%81%E5%8B%9D%E5%88%A9%EF%BC%81%0A%0A%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E8%A9%B3%E7%B4%B0%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%0Ahttps%3A%2F%2Fstrucknazo.web.app%0A%40evesanta1224%20%E3%81%8B%E3%82%89"
              target="_blank" class="secret-share-button">
              <i class="fab fa-x-twitter"></i>
              シェアする
            </a>
          </div>

          <button @click="closeQuiz4Modal1" class="secret-close-button">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 4問目正解モーダル（2つ目の正解） -->
    <div v-if="quiz4Modal2" class="secret-modal-overlay" @click="closeQuiz4Modal2">
      <div class="secret-modal" @click.stop>
        <div class="secret-modal-content">
          <h2 class="secret-title">ノーヒット<br class="br-sp">ノーラン</h2>
          <p class="secret-message">1枚だけで正解しました！</p>

          <div class="secret-share-section">
            <a href="https://twitter.com/intent/tweet?text=%23%E3%83%8A%E3%82%BE%E3%83%A9%E3%83%83%E3%82%AF%E3%82%A2%E3%82%A6%E3%83%88%0A%E3%80%90%E3%81%8A%E8%A9%A6%E3%81%97%E3%81%AA%E3%81%9E%E3%80%91%E3%83%8E%E3%83%BC%E3%83%92%E3%83%83%E3%83%88%E3%83%8E%E3%83%BC%E3%83%A9%E3%83%B3%E9%81%94%E6%88%90%EF%BC%81%0A%0A%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E8%A9%B3%E7%B4%B0%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%0Ahttps%3A%2F%2Fstrucknazo.web.app%0A%40evesanta1224%20%E3%81%8B%E3%82%89"
              target="_blank" class="secret-share-button">
              <i class="fab fa-x-twitter"></i>
              シェアする
            </a>
          </div>

          <button @click="closeQuiz4Modal2" class="secret-close-button">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- exile_te.gif用モーダル -->
    <div v-if="exileTeModal" class="secret-modal-overlay" @click="closeExileTeModal">
      <div class="secret-modal" @click.stop>
        <div class="secret-modal-content">
          <h2 class="secret-title">隠し要素を<br class="br-sp">見つけた！</h2>
          <p class="secret-message">あいつらが手をぶん回した！</p>

          <div class="secret-share-section">
            <a href="https://twitter.com/intent/tweet?text=%23%E3%83%8A%E3%82%BE%E3%83%A9%E3%83%83%E3%82%AF%E3%82%A2%E3%82%A6%E3%83%88%0A%E3%80%90%E9%9A%A0%E3%81%97%E8%A6%81%E7%B4%A0%E3%82%92%E8%A6%8B%E3%81%A4%E3%81%91%E3%81%9F%EF%BC%81%E3%80%91%0A%E6%89%8B%E3%82%92%E3%81%B6%E3%82%93%E5%9B%9E%E3%81%97%E3%81%9F%EF%BC%81%0A%0A%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E8%A9%B3%E7%B4%B0%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%0Ahttps%3A%2F%2Fstrucknazo.web.app%0A%40evesanta1224%20%E3%81%8B%E3%82%89%20"
              target="_blank" class="secret-share-button">
              <i class="fab fa-x-twitter"></i>
              シェアする
            </a>
          </div>

          <button @click="closeExileTeModal" class="secret-close-button">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- throw関数用モーダル -->
    <div v-if="throwModal" class="secret-modal-overlay" @click="closeThrowModal">
      <div class="secret-modal" @click.stop>
        <div class="secret-modal-content">
          <h2 class="secret-title">見てはいけないものを見た！</h2>
          <p class="secret-message">これ以上詮索しないで！！！<br>友達になろ！</p>

          <div class="secret-share-section">
            <a href="https://twitter.com/intent/tweet?text=%23%E3%83%8A%E3%82%BE%E3%83%A9%E3%83%83%E3%82%AF%E3%82%A2%E3%82%A6%E3%83%88%0A%E3%80%90%E8%A6%8B%E3%81%A6%E3%81%AF%E3%81%84%E3%81%91%E3%81%AA%E3%81%84%E3%82%82%E3%81%AE%E3%82%92%E8%A6%8B%E3%81%9F%EF%BC%81%E3%80%91%0A%0A%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%AE%E8%A9%B3%E7%B4%B0%E3%81%AF%E3%81%93%E3%81%A1%E3%82%89%0Ahttps%3A%2F%2Fstrucknazo.web.app%0A%40evesanta1224%20%E3%81%8B%E3%82%89%20"
              target="_blank" class="secret-share-button">
              <i class="fab fa-x-twitter"></i>
              シェアする
            </a>
          </div>

          <button @click="closeThrowModal" class="secret-close-button">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  name: 'HomeView',
  data() {
    return {
      currentQuizIndex: 0,
      userAnswer: '',
      showResult: false,
      isCorrect: false,
      userAnswers: ['', '', '', ''], // 各問題の回答を保存
      showResults: [false, false, false, false], // 各問題の結果表示状態
      isCorrects: [false, false, false, false], // 各問題の正誤状態
      quizImages: [
        require('../assets/ota/otaA.png'),
        require('../assets/ota/otaB.png'),
        require('../assets/ota/otaC.png'),
        require('../assets/ota/otaD.png')
      ],
      quizAnswers: [
        ["ball", "Ball", "ボール", "ぼーる"], // 1.pngの正解
        ["パズル", "puzzle", "ぱずる", "Puzzle"], // 2.pngの正解
        ["panel", "Panel", "ぱねる", "パネル"], // 3.pngの正解
        ["カンプウ", "かんぷう", "完封"]  // 4.pngの正解（1種類目）
      ],
      quizAnswers2: [
        null, // 1.pngには2種類目の答えなし
        null, // 2.pngには2種類目の答えなし
        null, // 3.pngには2種類目の答えなし
        ["直球", "ちょっきゅう", "チョッキュウ"]  // 4.pngの正解（2種類目）
      ],
      secretCnt: 0,
      secretModal: false,
      exileTeModal: false, // exile_te.gif用のモーダル
      quiz4Modal1: false,
      quiz4Modal2: false,
      throwModal: false, // throw関数用のモーダル
      exileImageSrc: require('../assets/icons/exile.png'), // 静止画（1枚目の画像）
      exileGifSrc: require('../assets/icons/exile.gif'),   // GIFアニメーション
      exileTeGifSrc: require('../assets/icons/exile_te.gif'), // 5回目以降のGIFアニメーション
      exileClickCount: 0, // exileアイコンのクリック回数をカウント
      tokeiImageSrc: require('../assets/icons/tokei.png'), // 時計の静止画
      tokeiGifSrc: require('../assets/icons/tokei.gif'),   // 時計のGIFアニメーション
      puzzleImageSrc: require('../assets/icons/puzzle.png'), // パズルの静止画
      puzzleGifSrc: require('../assets/icons/puzzle.gif'),   // パズルのGIFアニメーション
      doorImageSrc: require('../assets/icons/door.png'), // ドアの静止画
      doorGifSrc: require('../assets/icons/door.gif'),   // ドアのGIFアニメーション
      imagesPreloaded: false, // 画像のプリロード状態
      feedbacks: [
        {
          body: 'まじ楽しかったから全人類行ったほうがいい'
        },
        {
          body: 'システムがスゲェ〜、おもろい！\nストラックアウトらしさと謎解きが上手く組み合わさってて楽しかった〜、謎の難易度のグラデーションも良きだったかも\n終わった後にこだわりとか聞けて良かったね'
        },
        {
          body: '面白かった〜！！！！！\n謎ももちろん面白いし、ギミックがすごい！\nめっちゃストラックアウト！\nみんなでワイワイできる要素がたくさんあって公演中も公演後もずっとわちゃわちゃしてました😋'
        },
        {
          body: 'すごいボリュームがある謎で楽しかった。私が好きなタイプの謎解きだと思った。'
        },
        {
          body: 'めちゃくちゃ面白かったです😆\n終始わちゃわちゃ、驚き、爆笑してました🤣'
        }
      ],
      currentFeedbackIndex: 0,
      feedbackAutoTimer: null,
      feedbackTrackIndex: 1,
      feedbackSliderEl: null,
      feedbackCardStride: 0,
      feedbackSliderPadding: 0,
      isProgrammaticFeedbackScroll: false,
      feedbackLoopResetRaf: null,
      feedbackScrollEndTimer: null,
      feedbackScrollSyncTimer: null,
      feedbackScrollRaf: null,
      feedbackCardElements: [],
      feedbackCenterOffset: 0,
      feedbackCenterShiftPercent: 0.0,
      feedbackDuplicateCount: 0,
      feedbackCardWidth: 350,
      feedbackGap: 5,
      feedbackLoopAdjusting: false
    }
  },
  mounted() {
    // コンポーネントのマウント完了後に画像のプリロードを開始
    this.$nextTick(() => {
      this.preloadImages()
    })
    
    // グローバルスコープにThrow関数を公開
    // aa
    window.Throw = this.throwFunction

    this.updateFeedbackLayout()
    this.updateFeedbackDuplicates()
    this.initializeFeedbackTrack()
    window.addEventListener('resize', this.updateFeedbackLayout)
    this.startFeedbackAutoSlide()
  },
  
  beforeDestroy() {
    // コンポーネントの破棄時にグローバル関数を削除
    delete window.Throw
    this.clearFeedbackAutoSlide()
    window.removeEventListener('resize', this.updateFeedbackLayout)
    if (this.feedbackSliderEl) {
      this.feedbackSliderEl.removeEventListener('scroll', this.handleFeedbackScroll)
      this.feedbackSliderEl.removeEventListener('touchend', this.handleFeedbackScrollEndEvent)
      this.feedbackSliderEl.removeEventListener('touchcancel', this.handleFeedbackScrollEndEvent)
      this.feedbackSliderEl.removeEventListener('wheel', this.handleFeedbackScrollEndEvent)
      this.feedbackSliderEl = null
    }
    if (this.feedbackLoopResetRaf) {
      cancelAnimationFrame(this.feedbackLoopResetRaf)
      this.feedbackLoopResetRaf = null
    }
    if (this.feedbackScrollEndTimer) {
      clearTimeout(this.feedbackScrollEndTimer)
      this.feedbackScrollEndTimer = null
    }
    if (this.feedbackScrollSyncTimer) {
      clearTimeout(this.feedbackScrollSyncTimer)
      this.feedbackScrollSyncTimer = null
    }
    if (this.feedbackScrollRaf) {
      cancelAnimationFrame(this.feedbackScrollRaf)
      this.feedbackScrollRaf = null
    }
  },
  computed: {
    currentQuizImage() {
      return this.quizImages[this.currentQuizIndex]
    },

    prevQuizImage() {
      if (this.currentQuizIndex > 0) {
        return this.quizImages[this.currentQuizIndex - 1]
      }
      return null
    },

    nextQuizImage() {
      if (this.currentQuizIndex < this.quizImages.length - 1) {
        return this.quizImages[this.currentQuizIndex + 1]
      }
      return null
    },

    feedbackSliderStyle() {
      const cardWidthValue = `min(100%, ${this.feedbackCardWidth}px)`
      return {
        '--feedback-card-width': cardWidthValue,
        '--feedback-gap': `${this.feedbackGap}%`,
        '--feedback-center-shift': `${this.feedbackCenterShiftPercent * 100}%`
      }
    },

    loopedFeedbacks() {
      const length = this.feedbacks.length
      if (!length) return []
      const duplicateCount = Math.min(this.feedbackDuplicateCount || 0, length)
      if (!duplicateCount) return [...this.feedbacks]
      const head = this.feedbacks.slice(0, duplicateCount)
      const tail = this.feedbacks.slice(length - duplicateCount)
      return [...tail, ...this.feedbacks, ...head]
    }
  },
  watch: {
    feedbacks: {
      immediate: true,
      deep: true,
      handler() {
        this.updateFeedbackDuplicates()
        this.$nextTick(() => {
          this.resetFeedbackPosition()
        })
      }
    }
  },
  methods: {
    updateFeedbackDuplicates() {
      const length = this.feedbacks.length || 0
      const duplicateCount = length ? Math.min(3, length) : 0
      this.feedbackDuplicateCount = duplicateCount
    },
    resetFeedbackPosition() {
      const baseIndex =
        this.feedbacks.length > 1 ? this.feedbackDuplicateCount : 0
      this.feedbackTrackIndex = baseIndex
      this.currentFeedbackIndex = this.computeCurrentFeedbackIndex(baseIndex)
      if (!this.feedbackSliderEl) return
      this.updateFeedbackStride()
      this.jumpToFeedbackIndex(baseIndex, false)
    },
    initializeFeedbackTrack() {
      this.feedbackSliderEl = this.$refs.feedbackSlider || null
      const baseIndex =
        this.feedbacks.length > 1 ? this.feedbackDuplicateCount : 0
      this.feedbackTrackIndex = baseIndex
      this.currentFeedbackIndex = this.computeCurrentFeedbackIndex(baseIndex)
      this.$nextTick(() => {
        this.updateFeedbackStride()
        this.cacheFeedbackCardElements()
        this.jumpToFeedbackIndex(this.feedbackTrackIndex, false)
      })
      if (this.feedbackSliderEl) {
        this.feedbackSliderEl.addEventListener('scroll', this.handleFeedbackScroll, {
          passive: true
        })
        this.feedbackSliderEl.addEventListener('touchend', this.handleFeedbackScrollEndEvent, {
          passive: true
        })
        this.feedbackSliderEl.addEventListener('touchcancel', this.handleFeedbackScrollEndEvent, {
          passive: true
        })
        this.feedbackSliderEl.addEventListener('wheel', this.handleFeedbackScrollEndEvent, {
          passive: true
        })
      }
    },
    updateFeedbackLayout() {
      const width = window.innerWidth
      if (width >= 1440) {
        this.feedbackCardWidth = 350
        this.feedbackGap = 3
      } else if (width >= 1200) {
        this.feedbackCardWidth = 350
        this.feedbackGap = 3.5
      } else if (width >= 1024) {
        this.feedbackCardWidth = 340
        this.feedbackGap = 4
      } else if (width >= 768) {
        this.feedbackCardWidth = 320
        this.feedbackGap = 5
      } else {
        this.feedbackCardWidth = 300
        this.feedbackGap = 6
      }
      this.$nextTick(() => {
        this.updateFeedbackStride()
        this.cacheFeedbackCardElements()
        this.jumpToFeedbackIndex(this.feedbackTrackIndex, false)
      })
    },
    cacheFeedbackCardElements() {
      const track = this.$refs.feedbackTrack
      this.feedbackCardElements = track
        ? Array.from(track.querySelectorAll('.feedback-card'))
        : []
    },
    updateFeedbackStride() {
      if (!this.feedbackSliderEl) return
      const sliderStyle = window.getComputedStyle(this.feedbackSliderEl)
      this.feedbackSliderPadding = parseFloat(sliderStyle.paddingLeft) || 0
      const trackEl = this.$refs.feedbackTrack
      const trackStyle = trackEl ? window.getComputedStyle(trackEl) : null
      const gapValue = trackStyle
        ? parseFloat(trackStyle.columnGap || trackStyle.gap || '0')
        : 0
      const cardEl = trackEl ? trackEl.querySelector('.feedback-card') : null
      if (!cardEl) {
        this.feedbackCardStride = 0
        this.feedbackCenterOffset = 0
        return
      }
      this.feedbackCardStride = cardEl.offsetWidth + gapValue
      const sliderWidth = this.feedbackSliderEl.clientWidth || 0
      this.feedbackCenterOffset = sliderWidth ? (sliderWidth - cardEl.offsetWidth) / 2 : 0
      this.cacheFeedbackCardElements()
    },
    nextFeedback(auto = false) {
      if (this.feedbacks.length <= 1) return
      const target = this.feedbackTrackIndex + 1
      this.setCurrentFeedbackIndex(target)
      this.jumpToFeedbackIndex(target, true)
      if (!auto) this.restartFeedbackAutoSlide()
    },
    previousFeedback() {
      if (this.feedbacks.length <= 1) return
      const target = this.feedbackTrackIndex - 1
      this.setCurrentFeedbackIndex(target)
      this.jumpToFeedbackIndex(target, true)
      this.restartFeedbackAutoSlide()
    },
    startFeedbackAutoSlide() {
      if (this.feedbackAutoTimer || this.feedbacks.length <= 1) return
      this.feedbackAutoTimer = setInterval(() => {
        this.nextFeedback(true)
      }, 6000)
    },
    clearFeedbackAutoSlide() {
      if (this.feedbackAutoTimer) {
        clearInterval(this.feedbackAutoTimer)
        this.feedbackAutoTimer = null
      }
    },
    pauseFeedbackAutoSlide() {
      this.clearFeedbackAutoSlide()
    },
    resumeFeedbackAutoSlide() {
      this.startFeedbackAutoSlide()
    },
    restartFeedbackAutoSlide() {
      this.clearFeedbackAutoSlide()
      this.startFeedbackAutoSlide()
    },
    jumpToFeedbackIndex(index, smooth = true) {
      if (!this.feedbackSliderEl || !this.feedbackCardStride) return
      const slider = this.feedbackSliderEl
      const sliderWidth = slider.clientWidth || 1
      const loopedLength = this.feedbackCardElements.length
      const floorIndex = Math.floor(index)
      const clampedIndex = loopedLength
        ? Math.max(0, Math.min(loopedLength - 1, floorIndex))
        : Math.max(0, floorIndex)
      const fraction = index - floorIndex
      const baseCard =
        loopedLength > 0 ? this.feedbackCardElements[clampedIndex] : null
      const cardWidth = baseCard ? baseCard.offsetWidth : sliderWidth * (this.feedbackCardWidth / 100)
      const stride = this.feedbackCardStride || cardWidth
      const baseCenterOffset = this.feedbackCenterOffset != null
        ? this.feedbackCenterOffset
        : (sliderWidth - cardWidth) / 2
      const shift = sliderWidth * (this.feedbackCenterShiftPercent || 0)
      const centerOffset = baseCenterOffset - shift
      const baseLeft =
        this.feedbackSliderPadding + floorIndex * stride
      const targetLeft =
        baseLeft + fraction * stride - centerOffset
      this.isProgrammaticFeedbackScroll = true
      if (!smooth) {
        this.disableFeedbackTransitions()
      } else {
        this.enableFeedbackTransitions()
      }
      this.feedbackSliderEl.scrollTo({
        left: targetLeft,
        behavior: smooth ? 'smooth' : 'auto'
      })
      if (this.feedbackScrollRaf) {
        cancelAnimationFrame(this.feedbackScrollRaf)
        this.feedbackScrollRaf = null
      }
      if (this.feedbackScrollSyncTimer) {
        clearTimeout(this.feedbackScrollSyncTimer)
        this.feedbackScrollSyncTimer = null
      }
      if (smooth) {
        this.enableFeedbackTransitions()
        this.feedbackScrollSyncTimer = setTimeout(() => {
          this.isProgrammaticFeedbackScroll = false
          this.feedbackScrollSyncTimer = null
        }, 650)
      } else {
        this.feedbackScrollRaf = requestAnimationFrame(() => {
          this.isProgrammaticFeedbackScroll = false
          this.enableFeedbackTransitions()
          this.feedbackScrollRaf = null
        })
      }
    },
    scheduleFeedbackLoopReset(targetFloatIndex) {
      if (this.feedbackLoopAdjusting) return
      this.feedbackLoopAdjusting = true
      if (this.feedbackLoopResetRaf) {
        cancelAnimationFrame(this.feedbackLoopResetRaf)
        this.feedbackLoopResetRaf = null
      }
      this.feedbackLoopResetRaf = requestAnimationFrame(() => {
        this.feedbackLoopResetRaf = null
        this.jumpToFeedbackIndex(targetFloatIndex, false)
        this.feedbackTrackIndex = targetFloatIndex
        this.currentFeedbackIndex = this.computeCurrentFeedbackIndex(targetFloatIndex)
        this.isProgrammaticFeedbackScroll = false
        this.$nextTick(() => {
          this.feedbackLoopAdjusting = false
        })
      })
    },
    scheduleFeedbackScrollEndCheck() {
      if (this.feedbackScrollEndTimer) {
        clearTimeout(this.feedbackScrollEndTimer)
      }
      this.feedbackScrollEndTimer = setTimeout(() => {
        this.feedbackScrollEndTimer = null
        this.handleFeedbackScrollEnd()
      }, 120)
    },
    disableFeedbackTransitions() {
      const slider = this.feedbackSliderEl
      const track = this.$refs.feedbackTrack
      if (slider) slider.classList.add('no-transition')
      if (track) track.classList.add('no-transition')
    },
    enableFeedbackTransitions() {
      const slider = this.feedbackSliderEl
      const track = this.$refs.feedbackTrack
      if (slider) slider.classList.remove('no-transition')
      if (track) track.classList.remove('no-transition')
    },
    handleFeedbackScroll() {
      if (!this.feedbackSliderEl || !this.feedbackCardStride) return
      if (this.feedbackLoopAdjusting) return
      const slider = this.feedbackSliderEl
      const totalItems = this.loopedFeedbacks.length
      if (!totalItems) return

      const baseCardWidth =
        (this.feedbackCardElements[0] && this.feedbackCardElements[0].offsetWidth) ||
        slider.clientWidth * (this.feedbackCardWidth / 100)
      const baseCenterOffset = this.feedbackCenterOffset != null
        ? this.feedbackCenterOffset
        : ((slider.clientWidth - baseCardWidth) / 2)
      const shift = slider.clientWidth * (this.feedbackCenterShiftPercent || 0)
      const centerOffset = baseCenterOffset - shift
      const adjustedScroll = slider.scrollLeft - this.feedbackSliderPadding + centerOffset
      const normalizedScroll = adjustedScroll < 0 ? 0 : adjustedScroll
      const stride = this.feedbackCardStride || 1
      const floatIndex = normalizedScroll / stride
      this.feedbackTrackIndex = floatIndex
      if (!this.isProgrammaticFeedbackScroll) {
        const duplicateCount = this.feedbackDuplicateCount
        const itemCount = this.feedbacks.length
        if (itemCount) {
          const minIndex = duplicateCount
          const maxIndex = duplicateCount + itemCount - 1
          const clampedIndex = Math.min(Math.max(floatIndex, minIndex), maxIndex)
          this.currentFeedbackIndex = this.computeCurrentFeedbackIndex(clampedIndex)
        } else {
          this.currentFeedbackIndex = 0
        }
        this.restartFeedbackAutoSlide()
      }
      this.scheduleFeedbackScrollEndCheck()
    },

    handleFeedbackScrollEnd() {
      if (!this.feedbackSliderEl || !this.feedbackCardStride) return
      if (this.feedbackLoopAdjusting) return
      const slider = this.feedbackSliderEl
      const totalItems = this.loopedFeedbacks.length
      if (!totalItems) return
      const baseCardWidth =
        (this.feedbackCardElements[0] && this.feedbackCardElements[0].offsetWidth) ||
        slider.clientWidth * (this.feedbackCardWidth / 100)
      const baseCenterOffset = this.feedbackCenterOffset != null
        ? this.feedbackCenterOffset
        : ((slider.clientWidth - baseCardWidth) / 2)
      const shift = slider.clientWidth * (this.feedbackCenterShiftPercent || 0)
      const centerOffset = baseCenterOffset - shift
      const adjustedScroll =
        slider.scrollLeft - this.feedbackSliderPadding + centerOffset
      const stride = this.feedbackCardStride || 1
      const floatIndex = adjustedScroll / stride
      const duplicateCount = this.feedbackDuplicateCount
      const itemCount = this.feedbacks.length
      if (!itemCount) return
      const minIndex = duplicateCount
      const maxIndex = duplicateCount + itemCount - 1
      if (floatIndex <= minIndex - 0.25) {
        const targetFloatIndex = floatIndex + itemCount
        this.scheduleFeedbackLoopReset(targetFloatIndex)
      } else if (floatIndex >= maxIndex + 0.25) {
        const targetFloatIndex = floatIndex - itemCount
        this.scheduleFeedbackLoopReset(targetFloatIndex)
      }
    },
    setCurrentFeedbackIndex(trackIndex) {
      this.feedbackTrackIndex = trackIndex
      this.currentFeedbackIndex = this.computeCurrentFeedbackIndex(trackIndex)
    },
    computeCurrentFeedbackIndex(trackIndex) {
      const total = this.feedbacks.length
      if (total <= 0) return 0
      const wrappedIndex = Math.round(trackIndex)
      const duplicateCount = this.feedbackDuplicateCount
      let normalized = wrappedIndex - duplicateCount
      normalized = ((normalized % total) + total) % total
      return normalized
    },
    handleFeedbackTouchStart() {
      this.pauseFeedbackAutoSlide()
    },
    handleFeedbackTouchEnd() {
      this.resumeFeedbackAutoSlide()
    },
    handleFeedbackScrollEndEvent() {
      this.scheduleFeedbackScrollEndCheck()
    },
    formatFeedbackBody(text) {
      if (!text) return ''
      return text.replace(/\n/g, '<br>')
    },
    nextQuiz() {
      if (this.currentQuizIndex < this.quizImages.length - 1) {
        this.currentQuizIndex++
        this.resetQuiz()
      }
    },
    previousQuiz() {
      if (this.currentQuizIndex > 0) {
        this.currentQuizIndex--
        this.resetQuiz()
      }
    },
    checkAnswer() {
      if (this.userAnswers[this.currentQuizIndex].trim() === '') return

      const userInput = this.userAnswers[this.currentQuizIndex].trim().toLowerCase()
      const currentAnswers = this.quizAnswers[this.currentQuizIndex]
      const currentAnswers2 = this.quizAnswers2[this.currentQuizIndex]

      // 1種類目の答えと一致するかチェック
      let isCorrect = currentAnswers.some(answer =>
        answer.toLowerCase() === userInput
      )

      // 2種類目の答えがある場合は、それとも一致するかチェック
      if (!isCorrect && currentAnswers2) {
        isCorrect = currentAnswers2.some(answer =>
          answer.toLowerCase() === userInput
        )
      }

      // 現在の問題の結果を保存
      this.isCorrects[this.currentQuizIndex] = isCorrect
      this.showResults[this.currentQuizIndex] = true

      // 4つ目に正解した場合、どの種類の答えかによってモーダルを表示
      if (isCorrect && this.currentQuizIndex === 3) {
        const userInput = this.userAnswers[this.currentQuizIndex].trim().toLowerCase()
        const currentAnswers = this.quizAnswers[this.currentQuizIndex]
        const currentAnswers2 = this.quizAnswers2[this.currentQuizIndex]

        // 1つ目の答えと一致する場合は1つ目のモーダル
        if (currentAnswers.some(answer => answer.toLowerCase() === userInput)) {
          this.quiz4Modal1 = true
        }
        // 2つ目の答えと一致する場合は2つ目のモーダル
        else if (currentAnswers2 && currentAnswers2.some(answer => answer.toLowerCase() === userInput)) {
          this.quiz4Modal2 = true
        }
      }
    },
    resetQuiz() {
      // 問題を切り替えても回答と結果は保持する（リセットしない）
      // 必要に応じて個別にリセットする場合は以下を使用
      // this.userAnswers[this.currentQuizIndex] = ''
      // this.showResults[this.currentQuizIndex] = false
      // this.isCorrects[this.currentQuizIndex] = false
    },

    handleHeroClick() {
      this.secretCnt = 1
    },

    handleHeroLeftClick() {
      if (this.secretCnt === 2) {
        this.secretModal = true
        this.secretCnt = 0
      } else {
        this.secretCnt = 0
      }
    },

    handleDoorClick() {
      if (this.secretCnt === 1) {
        this.secretCnt = 2
      } else {
        this.secretCnt = 0
      }
    },

    closeSecretModal() {
      this.secretModal = false
    },

    closeQuiz4Modal1() {
      this.quiz4Modal1 = false
    },

    closeQuiz4Modal2() {
      this.quiz4Modal2 = false
    },

    closeExileTeModal() {
      this.exileTeModal = false
    },

    closeThrowModal() {
      this.throwModal = false
    },

    playExileAnimation() {
      // クリック回数をカウント
      this.exileClickCount++
      
      // 3回目以降はexile_te.gifを再生
      if (this.exileClickCount >= 3) {
        this.exileImageSrc = this.exileTeGifSrc
        
        // 3回目の場合は4秒後にモーダルを表示
        if (this.exileClickCount === 3) {
          setTimeout(() => {
            this.exileTeModal = true
          }, 4000)
        }
      } else {
        // 2回目までは通常のexile.gifを再生
        this.exileImageSrc = this.exileGifSrc
      }
      
      this.secretCnt = 0

      // 4秒後に静止画に戻す
      setTimeout(() => {
        this.exileImageSrc = require('../assets/icons/exile.png')
      }, 4000)
    },

    playTokeiAnimation() {
      // GIFアニメーションに切り替え
      this.tokeiImageSrc = this.tokeiGifSrc
      this.secretCnt = 0

      // 4秒後に静止画に戻す
      setTimeout(() => {
        this.tokeiImageSrc = require('../assets/icons/tokei.png')
      }, 4000)
    },

    playPuzzleAnimation() {
      // GIFアニメーションに切り替え
      this.puzzleImageSrc = this.puzzleGifSrc
      if (this.secretCnt === 1) {
        this.secretCnt = 2
      } else {
        this.secretCnt = 0
      }

      // 4秒後に静止画に戻す
      setTimeout(() => {
        this.puzzleImageSrc = require('../assets/icons/puzzle.png')
      }, 4000)
    },

    playDoorAnimation() {
      // GIFアニメーションに切り替え
      this.doorImageSrc = this.doorGifSrc
      this.secretCnt = 0

      // 4秒後に静止画に戻す
      setTimeout(() => {
        this.doorImageSrc = require('../assets/icons/door.png')
      }, 4000)
    },



    scrollToQuiz() {
      const quizSection = document.getElementById('quiz-section')
      if (quizSection) {
        const offset = 150 // 上に150pxずらす
        const elementPosition = quizSection.offsetTop - offset

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        })
      }
    },

    // 画像のプリロードを行う
    preloadImages() {
      const imagesToPreload = [
        this.exileGifSrc,
        this.exileTeGifSrc, // exile_te.gifをプリロードに追加
        this.tokeiGifSrc,
        this.puzzleGifSrc,
        this.doorGifSrc,
        ...this.quizImages
      ]

      let loadedCount = 0
      const totalImages = imagesToPreload.length

      imagesToPreload.forEach((src, index) => {
        const img = new Image()
        img.onload = () => {
          loadedCount++
          if (loadedCount === totalImages) {
            this.imagesPreloaded = true
          }
        }
        img.onerror = () => {
          console.warn(`画像のプリロードに失敗しました: ${src}`)
          loadedCount++
          if (loadedCount === totalImages) {
            this.imagesPreloaded = true
          }
        }
        img.src = src
      })
    },
    
            // コンソールから呼び出せるThrow関数
    // 実行したい処理を追加
    throwFunction(key) {
      const h = "27ab0369c28ad00ef19d1bed285120a9"
      const keyStr = String(key ?? '')
      // 想定は「10桁の数字」。型ブレや余計な文字を除外して常に安定した判定にする。
      if (!/^\d{10}$/.test(keyStr)) {
        console.log('引数は「23号線の4と7の間の点を除いた10桁」です。')
        return
      }
      // MD5計算処理
      const md5Hash = CryptoJS.MD5(keyStr).toString()
      
      if (md5Hash === h) {
        this.throwModal = true
      } else {
        console.log('引数は「23号線の4と7の間の点を除いた10桁」です。')
        console.log(md5Hash)
      }
    }
  }
}
</script>

<style scoped>
.home {
  width: 100vw;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: #037a42;
  color: #ffffff;
  font-family: 'Noto Sans JP', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  overflow-x: hidden;
  color: #fff;
}

/* ヒーローセクション */
.hero-section {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 0;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../assets/struckhaikei.png') center/cover;
  opacity: 0.3;
  z-index: -1;
}

.hero-content {
  text-align: center;
  z-index: 1;
  padding: 0;
  width: 100%;
  margin-top: 0;
}

.hero-click-area {
  position: absolute;
  width: 50%;
  height: 50%;
  z-index: 10;
}

.hero-click-area.right {
  top: 0;
  right: 0;
}

.hero-click-area.left {
  top: 0;
  left: 0;
}

.hero-title-desktop {
  max-width: 100vw;
  width: auto;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.5));
}

.hero-title-mobile {
  display: none;
  max-width: 100vw;
  width: auto;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.5));
}

.br-sp {
    display: none;
}

/* メインビジュアルアニメーション */
.animate-in {
  animation: heroEntrance 1.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes heroEntrance {
  0% {
    transform: scale(1.6) rotate(-10deg);
    opacity: 0;
  }

  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}

.hero-subtitle {
  font-size: 1.5rem;
  font-weight: 600;
  color: #e8e8e8;
  margin-top: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* メインコンテンツ */
.main-content {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
  padding-left: 10vw;
  padding-right: 10vw;

}

/* メインタイトル */
.main-title-container {
  margin-bottom: 1rem;
}

.main-title-link {
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  color: #dac522;
  transition: all 0.3s ease;
}

.main-title-link:hover {
  color: #d4cb1c;
  transform: translateY(-1px);
}

.main-title-link i {
  margin-right: 0.5em;
  color: #dac522;
}

.title-icon {
  font-size: 4rem;
  color: #64b5f6;
  margin-bottom: 1rem;
  display: block;
}

.main-title {
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 0;
  background: linear-gradient(45deg, #dac522, #d4cb1c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-family: 'Noto Sans JP', sans-serif;
  letter-spacing: 0.05em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.main-subtitle {
  font-size: 1.3rem;
  color: #b0b0b0;
  font-weight: 600;
}

.sentence {
  font-size: 1rem;
  font-weight: 600;
  color: #fefefe;
}

.sentence-section {
  margin-top: 2rem;
}

.sentence-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fefefe;
  margin-bottom: 0.5rem;
  background: linear-gradient(45deg, #dac522, #d4cb1c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-top: 1rem;
  font-family: 'Noto Sans JP', sans-serif;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}


.sentence-content {
  font-size: 1rem;
  font-weight: 500;
  color: #fefefe;
  margin-top: 0;
}

.story-action-section {
  font-family: inherit;
  text-align: center;
  margin-top: 2rem;
}

.story-quiz-link {
  display: inline-flex;
  align-items: center;
  gap: 0.7em;
  background: linear-gradient(90deg, #dac522 0%, #d4cb1c 100%);
  color: #222;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0.8em 1.5em;
  border-radius: 2em;
  box-shadow: 0 4px 16px rgba(218, 197, 34, 0.18);
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.story-quiz-link:hover {
  background: linear-gradient(90deg, #dac522 60%, #fffbe6 100%);
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 8px 24px rgba(218, 197, 34, 0.28);
}

.hashtag{
  text-align: center;
  margin-top: 2rem;

  a {
    display: inline-flex;
    align-items: center;
    gap: 0.7em;
    background: linear-gradient(90deg, #dac522 0%, #d4cb1c 100%);
    color: #222;
    font-weight: bold;
    font-size: 1.1rem;
    padding: 0.8em 1.5em;
    border-radius: 2em;
    box-shadow: 0 4px 16px rgba(218, 197, 34, 0.18);
    text-decoration: none;
    transition: all 0.3s ease;
    border: none;
    font-family: 'Roboto', sans-serif;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  a:hover {
    background: linear-gradient(90deg, #dac522 60%, #fffbe6 100%);
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 8px 24px rgba(218, 197, 34, 0.28);
  }
}





/* フッター */
.footer {
  background: rgba(0, 0, 0, 0.3);
  padding: 2rem;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
}

.footer-content p {
  color: #888;
  font-size: 0.9rem;
}

/* フッター */
.footer {
  position: relative;
  padding: 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.1);
  margin-top: 2rem;
  padding-top: 1rem;
  padding-bottom: 2rem;
}

.footer-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-text {
  margin: 0;
  color: #ffffff;
  font-size: 0.9rem;
  opacity: 0.8;
}

.footer-links {

  font-family: inherit;
  display: flex;
  align-items: center;
}

.creator-link {
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
  gap: 0.7em;
  color: #fefefe;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0.8em 1.5em;
  border-radius: 2em;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  z-index: 10;
  line-height: 1;
}

.creator-link i {
  font-size: 1.1rem;
  color: #fefefe;
  display: flex;
  align-items: flex-end;
  line-height: 1;
  vertical-align: bottom;
  position: relative;
  top: 0;
}

/* お試しなぞセクションのスタイル */
.quiz-container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: #fdfdfd;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(218, 197, 34, 0.18);
  border: 1px solid #dac522;
}

.quiz-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  margin-bottom: 0.5rem;
  position: relative;
  overflow: hidden;
}

.nav-button {
  background: linear-gradient(90deg, #dac522 0%, #d4cb1c 100%);
  color: #222;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  box-shadow: 0 4px 15px rgba(218, 197, 34, 0.18);
  z-index: 2;
}

.nav-button:hover:not(.disabled) {
  transform: scale(1.1);
  box-shadow: 0 8px 25px rgba(218, 197, 34, 0.28);
}

.nav-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #ccc;
}

.quiz-image-container {
  flex: 1;
  max-width: 700px;
  position: relative;
  overflow: hidden;
  z-index: 10;
}

.quiz-image {
  max-width: 100%;
  height: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.prev-quiz-preview {
  position: absolute;
  right: 82%;
  top: 50%;
  transform: translateY(-50%);
  width: 90%;
  height: auto;
  text-align: center;
  opacity: 0.7;
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
}

.next-quiz-preview {
  position: absolute;
  left: 82%;
  top: 50%;
  transform: translateY(-50%);
  width: 90%;
  height: auto;
  text-align: center;
  opacity: 0.7;
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
}

.prev-quiz-preview:hover {
  opacity: 0.6;
}

.prev-quiz-preview:hover .preview-image {
  opacity: 0.9;
  transform: scale(0.9);
}

.next-quiz-preview:hover {
  opacity: 0.6;
}

.next-quiz-preview:hover .preview-image {
  opacity: 0.9;
  transform: scale(0.9);
}

.preview-label {
  font-size: 0.7rem;
  color: #ffffff;
  margin-bottom: 0.3rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  opacity: 0.8;
}

.preview-image {
  width: 90%;
  height: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  opacity: 0.7;
  transform: scale(0.85);
}

.quiz-answer-section {
  margin-top: 2rem;
}

.quiz-question {
  font-size: 1.2rem;
  color: #ffffff;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.answer-input-container {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.answer-input {

  font-family: inherit;
  padding: 0.8rem 1rem;
  border: 2px solid #dac522;
  border-radius: 8px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  min-width: 250px;
}

.answer-input:focus {
  outline: none;
  border-color: #d4cb1c;
  box-shadow: 0 0 10px rgba(218, 197, 34, 0.3);
}

.check-button {

  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  background: linear-gradient(90deg, #dac522 0%, #d4cb1c 100%);
  color: #222;
  border: none;
  border-radius: 2em;
  padding: 0.8em 1.5em;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(218, 197, 34, 0.18);
}

.check-button:hover {
  background: linear-gradient(90deg, #dac522 60%, #fffbe6 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(218, 197, 34, 0.28);
}

.answer-result {
  margin: 0.5rem 1rem;
  padding: 1rem;
  border-radius: 8px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.1rem;
}

.answer-result.correct {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
  border: 2px solid #4caf50;
}

.answer-result.incorrect {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
  border: 2px solid #f44336;
}

.quiz-progress {
  margin-top: 1.5rem;
  color: #ffffff;
  font-size: 1rem;
  opacity: 0.8;
}



/* シークレットモーダルのスタイル */
.secret-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.secret-modal {
  background: linear-gradient(135deg, #037a42 0%, #098a45 50%, #069592 100%);
  border-radius: 20px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 3px solid #dac522;
  margin-left: 10vw;
  margin-right: 10vw;
}

.secret-modal-content {
  text-align: center;
  color: #ffffff;
}

.secret-title {
  font-size: 2rem;
  font-weight: bold;
  color: #dac522;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.secret-message {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.secret-share-section {
  margin-bottom: 2rem;
}

.secret-share-button {
  display: inline-flex;
  align-items: center;
  gap: 0.7em;
  background: linear-gradient(90deg, #dac522 0%, #d4cb1c 100%);
  color: #222;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0.8em 1.5em;
  border-radius: 2em;
  box-shadow: 0 4px 16px rgba(218, 197, 34, 0.18);
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.secret-share-button:hover {
  background: linear-gradient(90deg, #dac522 60%, #fffbe6 100%);
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 8px 24px rgba(218, 197, 34, 0.28);
}

.secret-close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #ffffff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.secret-close-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

/* 管理者ボタン */
.admin-button {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 40px;
  background: transparent;
  color: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: none;
  z-index: 1;
}

.admin-button:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);
}

/* イベント概要セクション */
.sentence-section {
  margin-bottom: 4rem;
}

.feedback-section {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.feedback-slider {
  position: relative;
  margin-top: 1.5rem;
  width: 100%;
  overflow-y: visible;
  overflow-x: auto;
  display: block;
  box-sizing: border-box;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  --feedback-card-width: 88%;
  --feedback-gap: 6%;
  --feedback-center-shift: 0%;
  padding-left: max(
    0%,
    calc((100% - var(--feedback-card-width, 88%)) / 2 - var(--feedback-center-shift, 0%))
  );
  padding-right: max(
    0%,
    calc((100% - var(--feedback-card-width, 88%)) / 2 + var(--feedback-center-shift, 0%))
  );
  scroll-padding-left: max(
    0%,
    calc((100% - var(--feedback-card-width, 88%)) / 2 - var(--feedback-center-shift, 0%))
  );
  scroll-padding-right: max(
    0%,
    calc((100% - var(--feedback-card-width, 88%)) / 2 + var(--feedback-center-shift, 0%))
  );
}

.feedback-slider::-webkit-scrollbar {
  display: none;
}

.feedback-slider.no-transition {
  scroll-behavior: auto;
}

.feedback-track {
  display: flex;
  align-items: stretch;
  gap: var(--feedback-gap, 6%);
  min-width: 100%;
}

.feedback-track.no-transition {
  transition: none !important;
}

.feedback-card {
  position: relative;
  flex: 0 0 var(--feedback-card-width, min(100%, 400px));
  max-width: var(--feedback-card-width, min(100%, 400px));
  scroll-snap-align: center;
  scroll-snap-stop: always;
  padding: 0.5rem 2rem;
  box-sizing: border-box;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin: 0 auto 2.5rem;
}

.feedback-card::after {
  content: "";
  position: absolute;
  margin: 0;
  bottom: -30px;
  right: 30px;
  width: 0;
  height: 0;
  border-top: 40px solid #ffffff;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  transform: rotate(-30deg);
}

.feedback-card-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1d1d1f;
  letter-spacing: 0.03em;
}

.feedback-card-body {
  font-size: 1rem;
  line-height: 1.4;
  color: #2a2a2a;
  margin: 0;
}

.feedback-card-author {
  margin-top: auto;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.05em;
  text-align: right;
  color: rgba(60, 60, 60, 0.8);
}

@media (min-width: 768px) {
  .feedback-slider {
    --feedback-card-width: 75%;
    --feedback-gap: 5%;
  }

  .feedback-card {
    padding: 3rem 3rem;
  }
}

@media (min-width: 1024px) {
  .feedback-slider {
    --feedback-card-width: 65%;
    --feedback-gap: 4%;
  }

  .feedback-card {
    padding: 1.25rem 2rem;
    font-size: 1.1rem;
  }

  .feedback-card-title {
    font-size: 1.5rem;
  }

  .feedback-card-author {
    font-size: 1.05rem;
  }
}

@media (min-width: 1440px) {
  .feedback-slider {
    --feedback-card-width: 55%;
    --feedback-gap: 3%;
  }
}

.overview-grid {
  margin-left: 10vw;
  margin-right: 10vw;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 2rem;
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 1rem;
}

.overview-item {
  padding: 1rem 1rem;
  border-radius: 10px;
  border: 1.5px solid #dac522;
  padding: 0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.overview-label {
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  background: linear-gradient(45deg, #dac522, #d4cb1c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0;
  text-align: center;
  line-height: 2;
}

.overview-content {
  display: inline-block;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
}

.overview-content i {
  font-size: 3rem;
  background: linear-gradient(45deg, #dac522, #d4cb1c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.overview-content .overview-icon {
  width: 3rem;
  height: 3rem;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.overview-content .overview-icon:hover {
  transform: scale(1.1);
}

.overview-content span {
  font-size: 1.1rem;
  background: linear-gradient(45deg, #dac522, #d4cb1c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 500;
  line-height: 2;
}

/* 開催日程テーブルのスタイル */
.schedule-table {
  width: 100%;
  max-width: 600px;
  margin: 2rem auto;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #dac522;
}

.schedule-table th {
  color: #dac522;
  padding: 1rem;
  font-weight: 600;
  text-align: center;
  font-size: 1.3rem;
  border: 1px solid #dac522;
}

.schedule-table td {
  padding: 1.2rem;
  text-align: center;
  color: #ffffff;
  font-size: 1rem;
  border: 1px solid #dac522;
}

.schedule-table tr:last-child td {
  border-bottom: none;
}

/* アクセスセクションのスタイル */
.access-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
}

.map-container {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1.5rem;
  text-align: center;
  display: flex;
  justify-content: center;
}

.address-info {
  margin-bottom: 0.5rem;
  color: #fefefe;
}

.address-text {
  font-size: 1rem;
  margin: 0;
  padding: 1rem;
  border-radius: 10px;
  display: inline-block;
}

.access-section .sentence-title {
  text-align: left;
}

.access-link {
  display: block;
  width: fit-content;
  margin: 0.5rem auto 0;
  align-items: center;
  gap: 0.7em;
  background: linear-gradient(90deg, #dac522 0%, #d4cb1c 100%);
  color: #222;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0.8em 1.5em;
  border-radius: 2em;
  box-shadow: 0 4px 16px rgba(218, 197, 34, 0.18);
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-align: center;
}

.access-link:hover {
  background: linear-gradient(90deg, #dac522 60%, #fffbe6 100%);
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 8px 24px rgba(218, 197, 34, 0.28);
}

/* チケット購入リンクのスタイル */
.ticket-section {

  font-family: inherit;
  text-align: center;
  margin-top: 2rem;
}

.ticket-link {
  display: inline-flex;
  align-items: center;
  gap: 0.7em;
  background: linear-gradient(90deg, #dac522 0%, #d4cb1c 100%);
  color: #222;
  font-weight: bold;
  font-size: 1.2rem;
  padding: 0.9em 2em;
  border-radius: 2em;
  box-shadow: 0 4px 16px rgba(218, 197, 34, 0.18);
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.ticket-link:hover {
  background: linear-gradient(90deg, #dac522 60%, #fffbe6 100%);
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 8px 24px rgba(218, 197, 34, 0.28);
}

.ticket-link i {
  font-size: 1.4em;
}

/* レスポンシブデザイン */
@media (min-width: 1024px) {
  .overview-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
    max-width: 1000px;
  }
}

@media (min-width: 769px) and (max-width: 1023px) {
  .overview-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    max-width: 900px;
  }
}

@media (max-width: 768px) {
  .hero-title-desktop {
    display: none;
  }

  .hero-title-mobile {
    display: block;
  }

  .hero-subtitle {
    font-size: 1.2rem;
  }

  .main-content {
    padding: 0rem 10rem;
  }

  .main-title {
    font-size: 3rem;
  }

  .title-icon {
    font-size: 3rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .action-button {
    min-width: 250px;
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }

  .sentence-title {
    font-size: 1.5rem;
  }

  .overview-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    max-width: 600px;
  }

  .overview-item {
    padding: 1.5rem;
  }

  .content-section {
    padding: 2rem 1.5rem;
    margin-bottom: 2rem;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .section-header p {
    font-size: 1rem;
  }

  .cta-button {
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .hero-content {
    padding: 0;
  }

  .hero-title-mobile {
    max-width: 100vw;
  }

  .main-content {
    padding: 0rem 1rem;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .title-icon {
    font-size: 2.5rem;
  }

  .features-grid {
    gap: 1rem;
  }

  .feature-card {
    padding: 1.5rem;
  }

  .action-button {
    min-width: 220px;
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }

  .sentence-title {
    font-size: 1.5rem;

  }

  .overview-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    max-width: 500px;
    margin-left: 10vw;
    margin-right: 10vw;
  }

  .overview-item {
    padding: 1rem 1rem;
  }

  .overview-label {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  .overview-content i {
    font-size: 3rem;
  }

  .overview-content span {
    font-size: 1rem;
  }

  .schedule-table {
    max-width: 100%;
    margin: 1.5rem auto;
    border: 1px solid #dac522;
  }

  .schedule-table th{
    padding: 0.8rem 0.5rem;
    font-size: 1.1rem;
  }

  .schedule-table td {
    padding: 0.8rem 0.5rem;
    font-size: 1.2rem;
  }

  .access-content {
    max-width: 100%;
    margin: 0 1rem;
  }

  .address-text {
    font-size: 1rem;
    padding: 0.8rem;
  }

  .access-content a {
    font-size: 1rem;
    padding: 0.6rem 1.2rem;
  }

  .ticket-link {
    font-size: 1rem;
    padding: 0.8em 1.5em;
  }

  .content-section {
    padding: 0;
  }

  .section-header h2 {
    font-size: 1.8rem;
  }

  .cta-button {
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }

  .nazonekos-image {
    width: 200px;
    height: auto;
    cursor: pointer;
    border-radius: 8px;
  }

  .nazonekos-image:hover {
    transform: scale(1.05);
  }
  .br-sp {
        display: block;
    }
}
</style>
